import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { DatepickerComponent } from "../datepicker/datepicker.component";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "rask-datepicker-interval",
    templateUrl: "./datepicker-interval.component.html",
    styleUrls: ["./datepicker-interval.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DatepickerComponent,
        FormsModule
    ]
})
export class DatepickerIntervalComponent implements OnInit {
    @Input() aid: string;
    @Input() onlyMonths = false;
    @Input() labelStartDate: string;
    @Input() labelEndDate: string;
    @Input() startDate: NgbDate | string;
    @Input() endDate: NgbDate | string;
    @Input() disabled: boolean;
    @Input() appendToBody = true;

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("startDate") startDateChange: EventEmitter<NgbDate | string> = new EventEmitter<NgbDate | string>();
    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("endDate") endDateChange: EventEmitter<NgbDate | string> = new EventEmitter<NgbDate | string>();

    // eslint-disable-next-line sonarjs/public-static-readonly
    static idTick = 0;

    ngOnInit() {
        this.parseAid();
    }

    set periodStart(date: NgbDate | string) {
        this.startDate = date;
        this.startDateChange.emit(date);
    }

    get periodStart() {
        return this.startDate;
    }

    set periodEnd(date: NgbDate | string) {
        this.endDate = date;
        this.endDateChange.emit(date);
    }

    get periodEnd() {
        return this.endDate;
    }

    set disableDatePicker(value: boolean) {
        this.disabled = value;
    }

    get disableDatePicker() {
        return this.disabled;
    }

    parseAid() {
        if (this.aid) {
            return;
        }
        this.aid = `${DatepickerIntervalComponent.idTick}+_aid`;
        DatepickerIntervalComponent.idTick++;
    }
}
